// extracted by mini-css-extract-plugin
module.exports = {"root":"header-module--root--Wc7zx","brand":"header-module--brand--18rL3","navButton":"header-module--navButton--3dVBR"};